const clients = new Map()

export function getSharedPusher(key) {
  if (!key || typeof window === "undefined" || !window.Pusher) return null
  let client = clients.get(key)
  if (!client) {
    client = new window.Pusher(key, { cluster: "mt1" })
    clients.set(key, client)
  }
  return client
}

export function resetSharedPusherForTests() {
  clients.clear()
}
